import React from "react";
import { useSelector } from "react-redux";
import { hasAnyRole } from "./authUtils";
import Unauthorized from "auth/Unauthorized";

const RequireRoles = ({ roles, showUnauthorized = true, children }) => {
  const user = useSelector(state => state.auth.user);
  const currentOrganization = useSelector(
    state => state.auth.currentOrganization,
  );

  if (hasAnyRole(user, roles) || hasAnyRole(currentOrganization, roles)) {
    return <>{children}</>;
  }

  if (showUnauthorized) {
    return (
      <Unauthorized message="You are not authorized to access this page." />
    );
  }

  return null;
};

export default RequireRoles;
